class FilterPosts {
  constructor() {
    this.year = document.querySelector('#filter-year');
    this.month = document.querySelector('#filter-month');
    this.search = document.querySelector('#filters-searchform');

    this.init();
  }

  init() {

    if (this.year) {
      this.year.addEventListener('change', this.filter);
    }

    if (this.month) {
      this.month.addEventListener('change', this.filter);
    }

    if (this.search) {
      this.search.addEventListener('keypress', event => {
        if (event.which === 13) {
          this.filter();
        }
      });
    }
  }

  filter = () => {
    let baseUrl = new URL(window.location.href);
    let search = this.search.querySelector('input').value;
    let month = this.month.value;
    let year = this.year.value;

    if (year === 'all') {
      baseUrl.searchParams.delete('y');
    } else {
      baseUrl.searchParams.set('y', year);
    }

    if (month === 'all') {
      baseUrl.searchParams.delete('mo');
    } else {
      baseUrl.searchParams.set('mo', month);
    }

    if (search === '') {
      baseUrl.searchParams.delete('q');
    } else {
      baseUrl.searchParams.set('q', search);
    }

    location.replace(baseUrl.href);
  }
}

export default FilterPosts;
